import { IAddress } from "../Model/Configuration/IAddress";
import { IItem } from "../Model/Storage/IItem";
import { flattenArray } from "./Array";
import { Configuration } from "./Configuration";
import {
  asNonWhiteSpaceString, isNullOrWhiteSpace, isString, joinNonEmpty
} from "./String";

export function getAddress(item: IItem): string {
  const address = Configuration.getAddress();
  const { country } = address;

  return joinNonEmpty(
    [...getAddressLine(item, address), ...getCityPostalCode(item, address), asNonWhiteSpaceString(item[country])],
    `, `
  );
}

// Funktion von @Markus Theel und @David Wagner
// etwas umgebaut von
export function getLine2(item: IItem): string {
  const line2 = item?.line2;
  if (Array.isArray(line2)) {
    return flattenArray(line2).join(`, `);
  }

  if (isNullOrWhiteSpace(line2)) {
    return ``;
  }

  return line2;
}

const extensionLineCountries = [`GB`];
function isExtensionLineCountry(countryCode: unknown): boolean {
  if (!isString(countryCode)) {
    return false;
  }
  return extensionLineCountries.includes(countryCode);
}

const cityPostalCodeCountries = [`GB`, `RU`];
function isCityPostalCodeCountry(countryCode: unknown): boolean {
  if (!isString(countryCode)) {
    return false;
  }
  return cityPostalCodeCountries.includes(countryCode);
}

function getAddressLine(item: IItem, addressConfig: IAddress): string[] {
  const { countryCode, addressLine, addressExtension } = addressConfig;
  return isExtensionLineCountry(item[countryCode])
    ? [asNonWhiteSpaceString(item[addressLine]), asNonWhiteSpaceString(item[addressExtension])]
    : [asNonWhiteSpaceString(item[addressExtension]), asNonWhiteSpaceString(item[addressLine])];
}

function getCityPostalCode(item: IItem, addressConfig: IAddress): string[] {
  const { countryCode, city, postalCode } = addressConfig;
  return isCityPostalCodeCountry(item[countryCode])
    ? [asNonWhiteSpaceString(item[city]), asNonWhiteSpaceString(item[postalCode])]
    : [asNonWhiteSpaceString(item[postalCode]), asNonWhiteSpaceString(item[city])];
}
